export default class OfferService {
  constructor($http) {
    this.$http = $http;
  }

  get_offer_ids(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_offer_ids',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save(offer) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/save',
      data: {offer: offer, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_matched_buyers(offer_id, filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/get_matched_buyers',
      data: {offer_id: offer_id, filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_matched_items(offer_id, buyer_id, filter, return_stocklist) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/get_matched_items',
      data: {offer_id: offer_id, buyer_id: buyer_id, filter: filter, return_stocklist: return_stocklist, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_matched_item(offer_id, buyer_id, filter, return_stocklist, item_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/get_matched_items',
      data: {offer_id: offer_id, buyer_id: buyer_id, filter: filter, return_stocklist: return_stocklist, item_id: item_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  create_personalized_offer(offer_id, items, user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/create_personalized_offer',
      data: {offer_id: offer_id, items: items, user_id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  create_offer_from_items(items, filter, offer_options) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/create_offer_from_items',
      data: {items: items, filter: filter, offer_options: offer_options, authenticity_token: window.token}
    });
  }
  
  create_offer_from_cut_analysis(items, offer_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/create_offer_from_cut_analysis',
      data: {items: items, offer_id: offer_id, authenticity_token: window.token}
    });
  }

  get_manage_data(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/get_manage_data',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_cut_pricing_results(offer_stock_item_ids, filter) {
    return this.$http.post(
      '/admin/marketplace/offers/get_cut_pricing_results',
    {offer_stock_item_ids: offer_stock_item_ids, filter: filter, authenticity_token: window.token}
    );
  }

  get_cut_analysis_xls(offer_stock_item_ids,results) {
    return this.$http.post(
      '/admin/marketplace/offers/get_cut_analysis_xls',
      {offer_stock_item_ids: offer_stock_item_ids, results: results, authenticity_token: window.token}
    );
  }

  get_stocklist_for_charges(offer_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/get_stocklist_for_charges',
      data: {offer_id: offer_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  set_item_term_charges(offer_id, items) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/set_item_term_charges',
      data: {offer_id: offer_id, items: items, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  set_offer_country_charges(offer_id, country_charge, countries) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/set_offer_country_charges',
      data: {offer_id: offer_id, country_charge: country_charge, countries: countries, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_country_charge(offer_id, charge_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/delete_country_charge',
      data: {offer_id: offer_id, charge_id: charge_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  search_for_inventories(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/search_for_inventories',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_supplier_shipment_cities(supplier_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_supplier_shipment_cities',
      params: {supplier_id: supplier_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_connections(offer_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_connections',
      params: {offer_id: offer_id}
    }).then(function(response) {
      return response.data;
    });
  }

  update_create_filters(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/update_create_filters',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_stocklist_from_parent(offer_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/update_stocklist_from_parent',
      data: {offer_id: offer_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_stocklists_from_parent(offers) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/offers/update_stocklists_from_parent',
      data: {offers: offers, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  send_updated_offers_email(offers, times) {
    return this.$http.post(
      '/admin/marketplace/offers/send_updated_offers_email',
      {offers: offers, times: times, authenticity_token: window.token}
    );
  }

  get_freight_rates_for_buyer(offer_id, delivery_country_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_freight_rates_for_buyer',
      params: {offer_id: offer_id, country_id: delivery_country_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_delivery_terms_for_buyer(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_delivery_terms_for_buyer',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_country_extra_charge(offer_id, supplier_id, country_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_country_extra_charge',
      params: {offer_id: offer_id, supplier_id: supplier_id, country_id: country_id}
    }).then(function(response) {
      return response.data;
    });
  }

  submit_ospp_price(offer_id, items, buyer_id, buyer_country_id, price, incoterm) {
    return this.$http.post(
      '/admin/marketplace/offers/submit_ospp_price',
      {offer_id: offer_id, items: items, buyer_id: buyer_id, buyer_country_id: buyer_country_id, price: price, incoterm: incoterm, authenticity_token: window.token}
    );
  }

  submit_ospp_price_charge(offer_id, items, buyer_id, buyer_country_id, charge, incoterm) {
    return this.$http.post(
      '/admin/marketplace/offers/submit_ospp_price_charge',
      {offer_id: offer_id, items: items, buyer_id: buyer_id, buyer_country_id: buyer_country_id, charge: charge, incoterm: incoterm, authenticity_token: window.token}
    );
  }

  get_prices_for_activation(offer_id, supplier_id, buyer_id, country_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/offers/get_prices_for_activation',
      params: {offer_id: offer_id, supplier_id: supplier_id, buyer_id: buyer_id, country_id: country_id}
    }).then(function(response) {
      return response.data;
    });
  }

  set_uspp_activation(id, status) {
    return this.$http.post(
      '/admin/marketplace/offers/set_uspp_activation',
      {id: id, status: status, authenticity_token: window.token}
    );
  }

  set_uspc_activation(id, status) {
    return this.$http.post(
      '/admin/marketplace/offers/set_uspc_activation',
      {id: id, status: status, authenticity_token: window.token}
    );
  }

  get_ospp_users(offer_id) {
    return this.$http.get(
      '/admin/marketplace/offers/get_ospp_users',
      {params: {offer_id: offer_id}}
    );
  }

  get_buyer_matched_items(filter) {
    return this.$http.post(
      '/admin/marketplace/offers/get_buyer_matched_items',
      {filter: filter, authenticity_token: window.token}
    );
  }

  delete(offer_id) {
    return this.$http.post(
      '/admin/marketplace/offers/delete_offer',
      {offer_id: offer_id, authenticity_token: window.token}
    );
  }

  update_supplier_pricings(offer_id, offer_date_mode) {
    return this.$http.post(
      '/admin/marketplace/offers/update_supplier_pricings',
      {offer_id: offer_id, offer_date_mode: offer_date_mode, authenticity_token: window.token}
    );
  }

  get_supplier_pricing_stocklist(offer_id, country_id) {
    return this.$http.get(
      '/admin/marketplace/offers/get_supplier_pricing_stocklist',
      {params: {offer_id: offer_id, country_id: country_id}}
    );
  }

  update_stock_items_price(offer_id, items, price, incoterm, country_id) {
    return this.$http.post(
      '/admin/marketplace/offers/update_stock_items_price',
      {offer_id: offer_id, items: items, price: price, incoterm: incoterm, country_id: country_id,  authenticity_token: window.token}
    );
  }

  update_stock_items_fca(items) {
    return this.$http.post(
      '/admin/marketplace/offers/update_stock_items_fca',
      {items: items, authenticity_token: window.token}
    );
  }

  update_stock_items_user_fca(items, user_id, offer_id, buyer_country_id) {
    return this.$http.post(
      '/admin/marketplace/offers/update_stock_items_user_fca',
      {items: items, user_id: user_id, offer_id: offer_id, buyer_country_id: buyer_country_id, authenticity_token: window.token}
    );
  }

  update_offer_version(offer_id) {
    return this.$http.post(
      '/admin/marketplace/offers/update_offer_version',
      {offer_id: offer_id, authenticity_token: window.token}
    );
  }

  send_matching_data(offer_id, users, custom_text, email_recipient) {
    return this.$http.post(
      '/admin/marketplace/offers/send_matching_data',
      {offer_id: offer_id, users: users, custom_text: custom_text, email_recipient: email_recipient, authenticity_token: window.token}
    );
  }

  create_matching_data_xls(offer_id, user_id, company_title, country_id, filter) {
    return this.$http.post(
      '/admin/marketplace/offers/create_matching_data_xls',
      {offer_id: offer_id, user_id: user_id, company_title: company_title, country_id: country_id, filter: filter, authenticity_token: window.token}
    );
  }

  create_campaign_xls(offer_id, user_id, company_title, country_id, filter) {
    return this.$http.post(
      '/admin/marketplace/offers/create_campaign_xls',
      {offer_id: offer_id, user_id: user_id, company_title: company_title, country_id: country_id, filter: filter, authenticity_token: window.token}
    ).then(
      function(resp){
        window.open(resp.data.xls);
      }
    );
  }

  add_users_to_offer_campaign(offer_id, users, filter) {
    return this.$http.post(
      '/admin/marketplace/offers/add_users_to_offer_campaign',
      {offer_id: offer_id, users: users, filter: filter, authenticity_token: window.token}
    );
  }

  save_user_charge(user_charge) {
    return this.$http.post(
      '/admin/marketplace/offers/save_user_charge',
      {user_charge: user_charge, authenticity_token: window.token}
    );
  }

  delete_user_charge(charge_id) {
    return this.$http.post(
      '/admin/marketplace/offers/delete_user_charge',
      {charge_id: charge_id, authenticity_token: window.token}
    );
  }

  save_offer_campaign_settings(offer_id, campaign_settings) {
    return this.$http.post(
      '/admin/marketplace/offers/save_offer_campaign_settings',
      {offer_id: offer_id, campaign_settings: campaign_settings, authenticity_token: window.token}
    );
  }

  find_campaign_recipients(offer_id, filter) {
    return this.$http.post(
      '/admin/marketplace/offers/find_campaign_recipients',
      {offer_id: offer_id, filter: filter, authenticity_token: window.token}
    );
  }

  copy_text_fields(source_campaign_id, offer_id) {
    return this.$http.post(
      '/admin/marketplace/offers/copy_offer_campaign_text_fields',
      {source_campaign_id: source_campaign_id, offer_id: offer_id, authenticity_token: window.token}
    );
  }
}

OfferService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/offer.service.js